exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2tqZyrBsFukHDEhYMNlset [class*=pt-input],._2tqZyrBsFukHDEhYMNlset [class*=pt-select]{width:100%!important}._2tqZyrBsFukHDEhYMNlset{max-width:500px;margin:auto;display:block}", ""]);

// exports
exports.locals = {
	"onboardingProfileForm": "_2tqZyrBsFukHDEhYMNlset"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules!./src/advocate/onboarding/components/profile_form.css
// module id = 1227
// module chunks = 0 1